import { copy } from './i18n';

export const formatCurrency = (amountCents: number, currency = 'MXN') =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amountCents / 100);

export const formatDate = (value?: string) => {
  if (!value) return copy.common.notSet;
  const date = new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return copy.common.notSet;
  return new Intl.DateTimeFormat('es-MX', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
};

export const formatDateTime = (value?: string) => {
  if (!value) return copy.common.notSet;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return copy.common.notSet;
  return new Intl.DateTimeFormat('es-MX', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};
